import { modes } from "../modes";
import { roles } from "../roles";
import { permissions } from "../permissions/permissions";

export const formPermissionProfiles = {
    CREATE_FORMS: {
        //[modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.FORMS.CREATE],
    },
    EDIT_FORM_RESPONSE: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.FORMS.EDIT_RESPONSE],
    },
}